import * as vars from '@fullstory/proto/fs/api/vars';
import {
  BatchGetSpecConfigsResponse,
  BatchGetSpecObjectConfigsResponse,
  BatchGetSpecObjectMappingsResponse,
  BatchGetSpecsResponse,
  DeleteSpecObjectMappingResponse,
  SpecTargetObjectType,
  UpdateSpecObjectConfigResponse,
  UpdateSpecObjectMappingResponse,
} from '@fullstory/proto/fs/services/search-settings';

export const LIST_SPECS_RESPONSE: BatchGetSpecsResponse = {
  specs: [
    {
      slug: 'E-commerce',
      metadata: {
        name: 'E-commerce',
        deprecated: false,
        displayName: '',
        notes: '',
        attributes: {
          Creator: 'FullStory',
          ActiveByDefaultForIndustries: 'e-commerce',
        },
      },
      objects: [
        {
          slug: 'E-commerce/Add to Cart Button',
          metadata: {
            name: 'Add to Cart Button',
            deprecated: false,
            displayName: '',
            notes: '',
            attributes: {},
          },
          targetObjectTypes: [SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_ELEMENT],
          properties: [],
        },
        {
          slug: 'E-commerce/Add to Wishlist Button',
          metadata: {
            name: 'Add to Wishlist Button',
            deprecated: false,
            displayName: '',
            notes: '',
            attributes: {},
          },
          targetObjectTypes: [SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_ELEMENT],
          properties: [],
        },
        {
          slug: 'E-commerce/Applied Coupon',
          metadata: {
            name: 'Applied Coupon',
            deprecated: false,
            displayName: '',
            notes: '',
            attributes: {},
          },
          targetObjectTypes: [SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_ELEMENT],
          properties: [],
        },
        {
          slug: 'E-commerce/Cart Shared',
          metadata: {
            name: 'Cart Shared',
            deprecated: false,
            displayName: '',
            notes: '',
            attributes: {},
          },
          targetObjectTypes: [
            SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_API_EVENT,
            SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_DEFINED_EVENT,
          ],
          properties: [
            {
              slug: 'E-commerce/Cart Shared/cart_id',
              metadata: {
                name: 'cart_id',
                deprecated: false,
                displayName: '',
                notes: '',
                attributes: {},
              },
              propertyTypes: [5],
            },
            {
              slug: 'E-commerce/Cart Shared/recipient',
              metadata: {
                name: 'recipient',
                deprecated: false,
                displayName: '',
                notes: '',
                attributes: {},
              },
              propertyTypes: [5],
            },
          ],
        },
        {
          slug: 'E-commerce/Order Confirmation',
          metadata: {
            name: 'Order Confirmation',
            deprecated: false,
            displayName: '',
            notes: '',
            attributes: {},
          },
          targetObjectTypes: [SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_PAGE],
          properties: [],
        },
        {
          slug: 'E-commerce/Product Tile',
          metadata: {
            name: 'Product Tile',
            deprecated: false,
            displayName: '',
            notes: '',
            attributes: {},
          },
          targetObjectTypes: [SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_ELEMENT],
          properties: [],
        },
      ],
    },
    {
      // This spec is not configurable (since it's not allowlisted in
      // specIsConfigurable) and not active (since it's not configurable). If
      // it's showing up in your tests and bedeviling you, you're probably not
      // using the standard spec redux selectors. (Or there's a bug.)
      slug: 'Not Configurable or Active',
      metadata: {
        name: 'Never Active',
        deprecated: false,
        displayName: '',
        notes: '',
        attributes: {},
      },
      objects: [],
    },
  ],
};

export const LIST_SPEC_CONFIGS_RESPONSE: BatchGetSpecConfigsResponse = {
  specConfigs: [{ specSlug: 'E-commerce', active: true }],
};

export const LIST_SPECS_MAPPINGS_RESPONSE: BatchGetSpecObjectMappingsResponse = {
  mappings: [
    {
      mapping: {
        objectSlug: 'E-commerce/Cart Shared',
        targetObjectId: '123',
        targetObjectType: SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_DEFINED_EVENT,
        properties: [],
      },
      metadata: null,
      specObjectMappingRecordMetadata: {
        autosuggested: false,
      },
    },
    {
      mapping: {
        objectSlug: 'E-commerce/Coupon Removed',
        targetObjectType: SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_DEFINED_EVENT,
        targetObjectId: 'Cumulative Layout Shift',
        properties: [
          {
            propertySlug: 'E-commerce/Coupon Removed/coupon_id',
            targetPropertyScope: vars.Scope.evt,
            targetPropertyName: 'timestamp_str',
            targetPropertyType: vars.Type.str,
          },
        ],
      },
      metadata: null,
      specObjectMappingRecordMetadata: {
        autosuggested: false,
      },
    },
    {
      mapping: {
        objectSlug: 'E-commerce/Order Submitted',
        targetObjectType: SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_DEFINED_EVENT,
        targetObjectId: 'First Input Delay',
        properties: [],
      },
      metadata: null,
      specObjectMappingRecordMetadata: {
        autosuggested: false,
      },
    },
    {
      mapping: {
        objectSlug: 'E-commerce/Coupon Input',
        targetObjectType: SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_ELEMENT,
        targetObjectId: 'fY4nFyU5w6RW',
        properties: [],
      },
      metadata: null,
      specObjectMappingRecordMetadata: {
        autosuggested: false,
      },
    },
    {
      mapping: {
        objectSlug: 'E-commerce/Product Listing Page',
        targetObjectType: SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_PAGE,
        targetObjectId: '3',
        properties: [],
      },
      metadata: null,
      specObjectMappingRecordMetadata: {
        autosuggested: false,
      },
    },
    {
      mapping: {
        objectSlug: 'E-commerce/Order Confirmation',
        targetObjectType: SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_PAGE,
        targetObjectId: '1',
        properties: [],
      },
      metadata: null,
      specObjectMappingRecordMetadata: {
        autosuggested: false,
      },
    },
    {
      mapping: {
        objectSlug: 'E-commerce/Order Completed',
        targetObjectType: SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_DEFINED_EVENT,
        targetObjectId: 'Defined Event Saved',
        properties: [],
      },
      metadata: null,
      specObjectMappingRecordMetadata: {
        autosuggested: false,
      },
    },
    {
      mapping: {
        objectSlug: 'E-commerce/Add to Wishlist Button',
        targetObjectType: SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_ELEMENT,
        targetObjectId: 'ObCnkIRD51I0',
        properties: [],
      },
      metadata: null,
      specObjectMappingRecordMetadata: {
        autosuggested: false,
      },
    },
    {
      mapping: {
        objectSlug: 'E-commerce/Add to Cart Button',
        targetObjectType: SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_ELEMENT,
        targetObjectId: 'fY4nFyU5w6RW',
        properties: [],
      },
      metadata: null,
      specObjectMappingRecordMetadata: {
        autosuggested: false,
      },
    },
    {
      mapping: {
        objectSlug: 'E-commerce/Product Detail Page',
        targetObjectType: SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_PAGE,
        targetObjectId: '3',
        properties: [],
      },
      metadata: null,
      specObjectMappingRecordMetadata: {
        autosuggested: false,
      },
    },
    {
      mapping: {
        objectSlug: 'E-commerce/Coupon Denied',
        targetObjectType: SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_DEFINED_EVENT,
        targetObjectId: 'ClickedSample',
        properties: [
          {
            propertySlug: 'E-commerce/Coupon Denied/cart_id',
            targetPropertyScope: vars.Scope.evt,
            targetPropertyName: '',
            targetPropertyType: vars.Type.str,
          },
          {
            propertySlug: 'E-commerce/Coupon Denied/coupon_id',
            targetPropertyScope: vars.Scope.evt,
            targetPropertyName: 'class_str',
            targetPropertyType: vars.Type.str,
          },
          {
            propertySlug: 'E-commerce/Coupon Denied/coupon_name',
            targetPropertyScope: vars.Scope.evt,
            targetPropertyName: 'name_str',
            targetPropertyType: vars.Type.str,
          },
          {
            propertySlug: 'E-commerce/Coupon Denied/order_id',
            targetPropertyScope: vars.Scope.evt,
            targetPropertyName: 'class_str',
            targetPropertyType: vars.Type.str,
          },
        ],
      },
      metadata: null,
      specObjectMappingRecordMetadata: {
        autosuggested: false,
      },
    },
  ],
};

export const BATCH_UPDATE_SPEC_MAPPING_RESPONSE: UpdateSpecObjectMappingResponse = {
  mapping: {
    mapping: {
      objectSlug: 'E-commerce/Coupon Denied',
      targetObjectType: SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_API_EVENT,
      targetObjectId: 'ClickedSample',
      properties: [
        {
          propertySlug: 'E-commerce/Coupon Denied/reason',
          targetPropertyScope: vars.Scope.evt,
          targetPropertyName: 'sample_str',
          targetPropertyType: vars.Type.str,
        },
        {
          propertySlug: 'E-commerce/Coupon Denied/order_id',
          targetPropertyScope: vars.Scope.evt,
          targetPropertyName: 'class_str',
          targetPropertyType: vars.Type.str,
        },
        {
          propertySlug: 'E-commerce/Coupon Denied/coupon_name',
          targetPropertyScope: vars.Scope.evt,
          targetPropertyName: 'name_str',
          targetPropertyType: vars.Type.str,
        },
        {
          propertySlug: 'E-commerce/Coupon Denied/coupon_id',
          targetPropertyScope: vars.Scope.evt,
          targetPropertyName: 'class_str',
          targetPropertyType: vars.Type.str,
        },
        {
          propertySlug: 'E-commerce/Coupon Denied/cart_id',
          targetPropertyScope: vars.Scope.evt,
          targetPropertyName: '',
          targetPropertyType: vars.Type.str,
        },
      ],
    },
    metadata: null,
    specObjectMappingRecordMetadata: {
      autosuggested: false,
    },
  },
};

export const DELETE_SPEC_MAPPING_RESPONSE: DeleteSpecObjectMappingResponse = {
  mappingId: {
    objectSlug: 'E-commerce/Coupon Denied',
    targetObjectType: SpecTargetObjectType.SPEC_TARGET_OBJECT_TYPE_DEFINED_EVENT,
    targetObjectId: 'ClickedSample',
  },
};

export const LIST_SPEC_OBJECT_CONFIGS_RESPONSE: BatchGetSpecObjectConfigsResponse = {
  configs: [
    {
      config: {
        objectSlug: 'E-commerce/Checkout Started',
        skipped: false,
        notes: 'hello',
      },
      metadata: null,
    },
    {
      config: {
        objectSlug: 'E-commerce/Coupon Applied',
        skipped: false,
        notes: 'hi',
      },
      metadata: null,
    },
    {
      config: {
        objectSlug: 'E-commerce/Product Tile',
        skipped: true,
        notes: '',
      },
      metadata: null,
    },
  ],
};

export const UPDATE_SPEC_CONFIG_RESPONSE: UpdateSpecObjectConfigResponse = {
  config: {
    config: {
      objectSlug: 'E-commerce/Cart Shared',
      skipped: true,
      notes: 'This is a test note.',
    },
    metadata: null,
  },
};
